import React, {useLayoutEffect, useRef, useState} from "react";
import {createPortal} from "react-dom";
import "./ReviewFilterPopover.css";

export default function ReviewFilterPopover({anchorRef, onClose, children, label = "Note filters", className = "", avoidRef}) {
  const panel = useRef(null), close = useRef(onClose);
  close.current = onClose;
  const [position, setPosition] = useState({visibility: "hidden"});
  const target = document.fullscreenElement || anchorRef.current?.closest("dialog[open]") || anchorRef.current?.closest(".dark,.light") || document.body;
  useLayoutEffect(() => {
    const place = () => {
      const rect = anchorRef.current?.getBoundingClientRect();
      if (!rect) return;
      const viewport = window.visualViewport;
      const left = viewport?.offsetLeft || 0, top = viewport?.offsetTop || 0;
      const width = viewport?.width || window.innerWidth, height = viewport?.height || window.innerHeight;
      const panelWidth = Math.min(320, width - 16);
      const below = top + height - rect.bottom - 16, above = rect.top - top - 16;
      const useBelow = below >= Math.min(340, height / 2) || below >= above;
      let maxHeight = Math.min(480, Math.max(100, useBelow ? below : above), height - 16);
      const actualHeight = Math.min(panel.current?.scrollHeight || maxHeight, maxHeight);
      const panelLeft = Math.max(left + 8, Math.min(rect.right - panelWidth, left + width - panelWidth - 8));
      let panelTop = Math.max(top + 8, Math.min(useBelow ? rect.bottom + 6 : rect.top - actualHeight - 6, top + height - actualHeight - 8));
      const avoid = avoidRef?.current?.getBoundingClientRect();
      if (avoid && panelLeft < avoid.right && panelLeft + panelWidth > avoid.left && panelTop < avoid.bottom && panelTop + actualHeight > avoid.top) {
        const availableAbove = avoid.top - top - 16;
        if (availableAbove < 100) {close.current(); return;}
        maxHeight = Math.min(maxHeight, availableAbove);
        panelTop = Math.max(top + 8, avoid.top - Math.min(panel.current?.scrollHeight || maxHeight, maxHeight) - 6);
      }
      setPosition({left: panelLeft, top: panelTop, width: panelWidth, maxHeight});
    };
    const outside = event => {
      if (!panel.current?.contains(event.target) && !anchorRef.current?.contains(event.target)) close.current();
    };
    const key = event => {if (event.key === "Escape") {event.preventDefault(); event.stopPropagation(); close.current(); anchorRef.current?.querySelector("button")?.focus();}};
    place();
    panel.current?.focus();
    window.addEventListener("resize", place);
    window.addEventListener("scroll", place, true);
    window.visualViewport?.addEventListener("resize", place);
    window.visualViewport?.addEventListener("scroll", place);
    document.addEventListener("pointerdown", outside);
    document.addEventListener("keydown", key, true);
    return () => {
      window.removeEventListener("resize", place); window.removeEventListener("scroll", place, true);
      window.visualViewport?.removeEventListener("resize", place); window.visualViewport?.removeEventListener("scroll", place);
      document.removeEventListener("pointerdown", outside); document.removeEventListener("keydown", key, true);
    };
  }, [anchorRef, avoidRef]);
  return createPortal(<div ref={panel} className={"filter-panel review-filter-popover " + className} role="dialog" aria-label={label} tabIndex={-1} style={position}>{children}</div>, target);
}
